module.exports = __webpack_public_path__ + "static/web-app-people-1e804c34c100e589fd83f32bb77cb28a.png";